export enum UnusedFleetQueryKeys {
  UnusedFleet = 'unusedFleet',
  DescriptionChoices = 'descriptionChoices'
}
